function Billing() {
    this.Id = -1;
    this.OrganizationId = -1;
    this.Month = "";
    this.DateValue = "";
    this.AbridgedValue = "";
    this.OffenderId = -1;
    this.__type = 'Billing:www.veritracks.com';
}
if (typeof exports !== 'undefined') {
    module.exports = Billing;
}